module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"fork-in-the-road\"-in-pasadena-california-4c0a81d45722170bc4f57b0f4ec30935.png";